<template>
  <div class="empty-pages-preview">
    <div class="illu-no-pages" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EmptyPagesPreview",
});
</script>

<style scoped lang="scss">
.empty-pages-preview {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-end;
  .illu-no-pages {
    margin: 0;
    width: 100%;
  }
}
</style>
